import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative',
    paddingTop: '56.25%',
    backgroundColor: '#000',
    borderRadius: 8,
    overflow: 'hidden',
    marginBottom: 0,
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 0,
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    outline: 'none',
  },
}))

export default useStyles
